// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OqHD","badges":"styles_badges__1TJcL"};